  import * as React from 'react';
import { BOOST_TYPE, BoostInput } from '@frontend/applications/AffiliatesApp/types/globalTypes';
import { map } from 'lodash';
import { getEmptyBoostInput } from '@frontend/applications/AffiliatesApp/utils';
import { Button } from '@frontend/shadcn/components/ui/button';
import { PlusIcon } from '@revfluence/fresh-icons/regular';
import { BoostDrawer } from './BoostDrawer';
import { ConfirmOfferCreation } from './ConfirmOfferCreation';
import { FormAsyncAction, IShopifyPromoCodeFormOptions, IShopifyPromoCodeFormValues, OfferFormAsyncActions, OfferFormModes, TDisabledMap, TFormValues } from '../../../types';
import { BoostTag } from './BoostTag';
import { BoostPreview } from './BoostPreview';

interface IProps {
  values: TFormValues;
  mode: OfferFormModes;
  handleFormAsyncActions?: (value: FormAsyncAction) => void,
  onFinish?: () => void;
  requiredFields: React.ReactNode,
  formOptionsData?: IShopifyPromoCodeFormOptions,
  isSubscriptionEnable: boolean,
  disabledShopify: TDisabledMap<IShopifyPromoCodeFormValues>
}

export const BoostListing = ({
  values, mode: offerMode, onFinish, requiredFields, handleFormAsyncActions, formOptionsData, isSubscriptionEnable, disabledShopify
}: IProps): JSX.Element => {
  const [isConfirmOfferCreationModalOpen, setIsConfirmOfferCreationModalOpen] = React.useState(false);
  const [isBoostDrawerOpen, setIsBoostDrawerOpen] = React.useState(false);
  const [drawerMode, setDrawerMode] = React.useState<'CREATE' | 'EDIT'>('CREATE');
  const [boostInFocus, setBoostInFocus] = React.useState<BoostInput | null>(getEmptyBoostInput(BOOST_TYPE.DISCOUNT_BOOST)); // current boost
  const boostsFromApi = React.useMemo(() => map(values.boosts) || [], [values]); // boosts in offer
  const [indexInFocus, setIndexInFocus] = React.useState<number | null>(null);
  const [isBoostPreviewOpen, setIsBoostPreviewOpen] = React.useState(false);
  // remove this state
  // const [boosts, setBoosts] = React.useState<BoostInput[]>(map(boostsFromApi, transformBoostFromApi) || []); // Final
  const setBoosts = (boosts: BoostInput[]) => {
    handleFormAsyncActions({
      action: OfferFormAsyncActions.UPDATE_FIELD,
      payload: { key: 'boosts', value: boosts },
    });
  };

    return (
      <>
        <>
          {(!boostsFromApi || boostsFromApi.length === 0) ? (
            <Button
              variant="ghost"
              type="button"
              className="w-full border border-dashed border-grey-3 bg-grey-1 cursor-pointer min-h-[56px] rounded-2xl mt-4"
              onClick={() => {
            if (offerMode === OfferFormModes.Create) {
              setIsConfirmOfferCreationModalOpen(true);
            } else {
              setDrawerMode('CREATE');
              setIsBoostDrawerOpen(true);
            }
           }}
            >
              <PlusIcon className="text-grey-3 mr-2" fontSize={12} />
              <span className="text-primary text-sm font-normal m-0">Create your first boost</span>
            </Button>
        ) : (
          <div className="flex flex-col gap-2">
            {boostsFromApi.map((boost, idx) => (
              <BoostTag
                key={boost.id || idx}
                boost={boost}
                onEdit={(e) => {
                  e.stopPropagation();
                  setIndexInFocus(idx);
                  setDrawerMode('EDIT');
                  setBoostInFocus({ ...boost });
                  setIsBoostDrawerOpen(true);
                }}
                onMore={(e) => {
                  e.stopPropagation();
                  // Add more menu logic here
                }}
                onPreview={(e) => {
                  e.stopPropagation();
                  setIndexInFocus(idx);
                  setBoostInFocus({ ...boost });
                  setIsBoostPreviewOpen(true);
                }}
              />
            ))}
            <div
              className="flex items-center gap-2 cursor-pointer mt-2"
              onClick={() => {
                setDrawerMode('CREATE');
                setIsBoostDrawerOpen(true);
              }}
            >
              <span className="text-lg">+</span>
              <span className="underline">Create Boost</span>
            </div>
          </div>
        )}
        </>
        {offerMode === OfferFormModes.Create &&
        <ConfirmOfferCreation
          isConfirmOfferCreationModalOpen={isConfirmOfferCreationModalOpen}
          setIsConfirmOfferCreationModalOpen={setIsConfirmOfferCreationModalOpen}
          onFinish={onFinish}
          requiredFields={requiredFields}
        />}
        {isBoostDrawerOpen && <BoostDrawer
          open={isBoostDrawerOpen}
          setOpen={setIsBoostDrawerOpen}
          boosts={boostsFromApi}
          setBoosts={setBoosts}
          boostInFocus={boostInFocus}
          setBoostInFocus={setBoostInFocus}
          mode={drawerMode}
          formOptionsData={formOptionsData}
          isSubscriptionEnable={isSubscriptionEnable}
          disabledShopify={disabledShopify}
          setIndexInFocus={setIndexInFocus}
          indexInFocus={indexInFocus}
          offer={values}
        />}
        {isBoostPreviewOpen && <BoostPreview
          isBoostPreviewOpen={isBoostPreviewOpen}
          setIsBoostPreviewOpen={setIsBoostPreviewOpen}
          boost={boostInFocus}
          onEdit={(e) => {
            e.stopPropagation();
            setIndexInFocus(boostInFocus?.id);
            setDrawerMode('EDIT');
            setBoostInFocus({ ...boostInFocus });
            setIsBoostDrawerOpen(true);
          }}
        />}
      </>
    );
  };
